import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './en.json';
import mr from './mr.json';
import hi from './hi.json'; 

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      mr: { translation: mr },
      hi: { translation: hi } 
    },
    fallbackLng: 'en',
    // ✅ THESE TWO LINES ARE THE FIX
    ns: ['translation'],
    defaultNS: 'translation',
    detection: {
      order: ['localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'], // Ensures stability after navigation
    },
    interpolation: { escapeValue: false }
  });

export default i18n;